import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';
import { useAuth } from '../context/AuthContext';

const API = 'https://api.sm-media.id';

export default function Team() {
  const { client } = useAuth();
  const isAdmin = client?.role !== 'editor'; // owner (role undefined/null) atau admin eksplisit dianggap admin
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'editor' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const fetchMembers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/users`);
      setMembers(res.data || []);
    } catch (e) {
      setError('Gagal memuat daftar tim');
    }
    setLoading(false);
  };

  useEffect(() => { fetchMembers(); }, []);

  const createMember = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.password) return;
    setSaving(true); setError('');
    try {
      await axios.post(`${API}/api/users`, form);
      setForm({ name: '', email: '', password: '', role: 'editor' });
      setShowAddModal(false);
      fetchMembers();
    } catch (e) {
      setError(e.response?.data?.error || 'Gagal menambah anggota tim');
    }
    setSaving(false);
  };

  const updateRole = async (id, role) => {
    try {
      await axios.put(`${API}/api/users/${id}`, { role });
      fetchMembers();
    } catch (e) {
      setError('Gagal mengubah role');
    }
  };

  const toggleActive = async (id, is_active) => {
    try {
      await axios.put(`${API}/api/users/${id}`, { is_active: !is_active });
      fetchMembers();
    } catch (e) {
      setError('Gagal mengubah status');
    }
  };

  const deleteMember = async (id, name) => {
    if (!window.confirm(`Hapus "${name}" dari tim?`)) return;
    try {
      await axios.delete(`${API}/api/users/${id}`);
      fetchMembers();
    } catch (e) {
      setError('Gagal menghapus anggota tim');
    }
  };

  return (
    <div style={{ paddingBottom: 40 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="ti ti-users" style={{ fontSize: 22 }}></i>Tim
          </h1>
          <p style={{ fontSize: 13, color: colors.textSecondary, marginTop: 2 }}>Kelola siapa saja yang bisa mengakses dashboard ini.</p>
        </div>
        {isAdmin && (
          <button onClick={() => setShowAddModal(true)} className="btn btn-gold" style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
            <i className="ti ti-user-plus" style={{ fontSize: 15 }}></i>Tambah Anggota
          </button>
        )}
      </div>

      {error && (
        <div style={{ padding: '10px 14px', background: colors.dangerMuted, color: colors.danger, borderRadius: radius.md, marginBottom: 16, fontSize: 13 }}>{error}</div>
      )}

      {!isAdmin && (
        <div style={{ padding: '10px 14px', background: colors.accentMuted, color: colors.accentText, borderRadius: radius.md, marginBottom: 16, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
          <i className="ti ti-info-circle" style={{ fontSize: 16 }}></i>Hanya Admin yang bisa menambah atau mengubah anggota tim.
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary }}>Memuat daftar tim...</div>
      ) : (
        <div style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, overflow: 'hidden' }}>
          {members.map((m, idx) => (
            <div key={m.id || 'owner'} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', borderBottom: idx < members.length - 1 ? `1px solid ${colors.border}` : 'none', flexWrap: 'wrap' }}>
              <div style={{ width: 38, height: 38, borderRadius: '50%', background: colors.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15, color: '#FFFFFF', flexShrink: 0 }}>
                {m.name.charAt(0).toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 140 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 6 }}>
                  {m.name}
                  {m.is_owner && <span style={{ fontSize: 10, background: colors.accentMuted, color: colors.accentText, borderRadius: 4, padding: '1px 6px', fontWeight: 700 }}>Pemilik</span>}
                </div>
                <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 2 }}>{m.email}</div>
              </div>
              {isAdmin && !m.is_owner ? (
                <select value={m.role} onChange={e => updateRole(m.id, e.target.value)} style={{ fontSize: 12, padding: '6px 10px' }}>
                  <option value="admin">Admin</option>
                  <option value="editor">Editor</option>
                </select>
              ) : (
                <span style={{ fontSize: 11, fontWeight: 600, padding: '4px 10px', borderRadius: 6, background: colors.bgCardMuted, color: colors.textSecondary, textTransform: 'capitalize' }}>{m.role}</span>
              )}
              {isAdmin && !m.is_owner && (
                <>
                  <button onClick={() => toggleActive(m.id, m.is_active)} title={m.is_active ? 'Nonaktifkan' : 'Aktifkan'}
                    style={{ background: 'transparent', border: 'none', color: m.is_active ? colors.success : colors.textSecondary, cursor: 'pointer', padding: 4 }}>
                    <i className={`ti ${m.is_active ? 'ti-toggle-right' : 'ti-toggle-left'}`} style={{ fontSize: 20 }}></i>
                  </button>
                  <button onClick={() => deleteMember(m.id, m.name)} style={{ background: 'transparent', border: 'none', color: colors.danger, cursor: 'pointer', padding: 4 }}>
                    <i className="ti ti-trash" style={{ fontSize: 16 }}></i>
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      )}

      {showAddModal && (
        <div onClick={() => setShowAddModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: colors.bgCard, borderRadius: radius.lg, padding: 24, maxWidth: 400, width: '100%' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary, marginBottom: 16 }}>Tambah Anggota Tim</h2>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Nama</label>
              <input type="text" placeholder="Nama lengkap..." value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={{ width: '100%' }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Email</label>
              <input type="email" placeholder="email@contoh.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={{ width: '100%' }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Password</label>
              <div style={{ position: 'relative' }}>
                <input type={showPassword ? 'text' : 'password'} placeholder="Minimal 6 karakter" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} style={{ width: '100%', paddingRight: 36, boxSizing: 'border-box' }} />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', padding: 4, color: colors.textSecondary }}>
                  <i className={`ti ${showPassword ? 'ti-eye-off' : 'ti-eye'}`} style={{ fontSize: 16 }}></i>
                </button>
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Role</label>
              <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} style={{ width: '100%' }}>
                <option value="editor">Editor — bisa buat & upload konten</option>
                <option value="admin">Admin — akses penuh</option>
              </select>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowAddModal(false)} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.borderStrong}`, background: colors.bgCard, color: colors.textPrimary, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Batal</button>
              <button onClick={createMember} disabled={saving} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: saving ? colors.border : colors.accent, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer' }}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
